import styled from 'styled-components';
import color from '../utils/style/color';
import space from '../utils/style/space';

const ModalBackground = styled.div`
  box-sizing: border-box;
  width: 100%;
  margin: ${space.xxs}px;
  padding: ${space.xxxl}px ${space.xxs}px;
  background-color: ${color.gray.xxxxBright};
  box-shadow: 0 0 1px 0 rgba(221, 221, 221, 0.5);
  border: solid 1px #e3e3e3;
  border-radius: 2px;

  @media (min-width: 481px) {
    max-width: 420px;
    padding: ${space.xxxl}px;
  }
`;

export default ModalBackground;
